import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { Menu } from '../models/database_models/menu';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
	providedIn: 'root'
})
export class MenuService {
	API_ENDPOINT: string = 'api/Menu/';
	API_URL: string = environment.API_URL + this.API_ENDPOINT;
	GET_MENUS: string = 'GetMenusByRole';

	constructor(private http: HttpClient) {
	}

	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.getItem('token')
		})
	};

	getMenus(roleId): Observable<Menu[]> {
		return this.http.get<Menu[]>(this.API_URL + this.GET_MENUS + '?roleId=' + roleId, this.httpOptions).pipe(
			catchError(this.handleError)
		);
	}

	handleError(err: HttpErrorResponse) {
		let errorMessage = '';
		if (err.error instanceof ErrorEvent) {
			errorMessage = 'menu.service.ts - Error' + err.error.message;
		} else {
			errorMessage = 'Sistemsel bir hata';
		}
		return throwError(errorMessage);
	}
}


